import { gql } from "@apollo/client";
import {
  GENERIC_IMAGE_FRAGMENT,
  PLP_REVIEW_FRAGMENT,
  RIBBON_FRAGMENT,
  PLP_PRICING_FRAGMENT,
  MARKETING_TILES_FRAGMENT,
  PRODUCT_CARD_PRICES_FRAGMENT
} from "lib/apollo/fragments";

export const GET_PLP = gql`
  query getPlp(
    $categoryUrlPath: String!
    $filters: [String!]
    $pagination: PaginationInput
    $sort: SortOptionEnum
    $isTypicalJourney: Boolean
    $marketingTilesPath: String!
    $branchName: String!
    $staged: Boolean
  ) {
    getPlp(
      categoryUrlPath: $categoryUrlPath
      filters: $filters
      pagination: $pagination
      sort: $sort
      isTypicalJourney: $isTypicalJourney
    ) {
      marketingTiles(
        categoryPath: $marketingTilesPath
        branchName: $branchName
        preview: $staged
      ) {
        ...MarketingTilesFragment
      }
      category {
        title
        description
        metaTitle
        metaDescription
        hreflangs {
          locale
          slug
        }
        variantCount
        productCount
        filters {
          slug
          label
          items {
            label
            slug
            subItems {
              label
              count
              slug
            }
          }
        }
        relatedCategories {
          title
          href
        }
        seo {
          id
          page
          terms
          noindex
          nofollow
          canonical
          pageHeaderDescription
          pageFooterDescription
        }
      }
      productCards {
        ... on MultipleProductCard {
          id
          type
          title
          brandName
          buttonText
          highlightedPrice
          swatchImages {
            id
            src
            altText
          }
          reviews {
            ...PlpReviewFragment
          }
          variants {
            shade
            slug
            href
            swatch {
              ...GenericImageFragment
            }
            sku
            slug
            href
            badge {
              ...GenericImageFragment
            }
            ribbon {
              ...RibbonFragment
            }
            images {
              ...GenericImageFragment
            }
            pricing {
              ...PlpPricingFragment
            }
            availability {
              inStock
            }
          }
        }
        ... on SingularProductCard {
          id
          type
          title
          brandName
          buttonText
          highlightedPrice
          reviews {
            ...PlpReviewFragment
          }
          variants {
            shade
            sku
            href
            badge {
              ...GenericImageFragment
            }
            ribbon {
              ...RibbonFragment
            }
            slug
            images {
              ...GenericImageFragment
            }
            pricing {
              ...PlpPricingFragment
            }
            prices {
              ...ProductCardPricesFragment
            }
            availability {
              inStock
            }
          }
        }
      }
    }
  }
  ${GENERIC_IMAGE_FRAGMENT}
  ${PLP_REVIEW_FRAGMENT}
  ${RIBBON_FRAGMENT}
  ${PLP_PRICING_FRAGMENT}
  ${PRODUCT_CARD_PRICES_FRAGMENT}
  ${MARKETING_TILES_FRAGMENT}
`;

export const SEARCH_SUGGESTION_QUERY = gql`
  query searchProducts(
    $term: String!
    $useGuestPrice: Boolean
    $isTypicalJourney: Boolean
  ) {
    searchProducts(
      term: $term
      useGuestPrice: $useGuestPrice
      isTypicalJourney: $isTypicalJourney
    ) {
      searchSuggestions(
        term: $term
        useGuestPrice: $useGuestPrice
        isTypicalJourney: $isTypicalJourney
      ) {
        ... on SearchResults {
          products {
            ... on MultipleProductCard {
              id
              type
              title
              brandName
              buttonText
              highlightedPrice
              swatchImages {
                id
                src
                altText
              }
              reviews {
                ...PlpReviewFragment
              }
              variants {
                shade
                slug
                href
                swatch {
                  ...GenericImageFragment
                }
                sku
                slug
                href
                badge {
                  ...GenericImageFragment
                }
                ribbon {
                  ...RibbonFragment
                }
                images {
                  ...GenericImageFragment
                }
                pricing {
                  ...PlpPricingFragment
                }
                prices {
                  ...ProductCardPricesFragment
                }
                availability {
                  inStock
                }
              }
            }
            ... on SingularProductCard {
              id
              type
              title
              brandName
              buttonText
              highlightedPrice
              reviews {
                ...PlpReviewFragment
              }
              variants {
                shade
                sku
                href
                badge {
                  ...GenericImageFragment
                }
                ribbon {
                  ...RibbonFragment
                }
                slug
                images {
                  ...GenericImageFragment
                }
                pricing {
                  ...PlpPricingFragment
                }
                prices {
                  ...ProductCardPricesFragment
                }
                availability {
                  inStock
                }
              }
            }
          }
        }
      }
    }
  }
  ${GENERIC_IMAGE_FRAGMENT}
  ${PLP_REVIEW_FRAGMENT}
  ${PLP_PRICING_FRAGMENT}
  ${RIBBON_FRAGMENT}
  ${PRODUCT_CARD_PRICES_FRAGMENT}
`;
